import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonText,
  IonCard,
  IonIcon,
  IonLabel,
} from "@ionic/react";
import { addCircle, shirt, cash, wallet } from "ionicons/icons";
import { useFirebase } from "../components/firebase-provider";

import PageLayout from "../components/layout";

const Dashboard: React.FC = () =>  {
  const { auth } = useFirebase();
  // Ucapan
  var myDate = new Date();
  var hrs = myDate.getHours();
  var greet;

  if (hrs >= 6 && hrs <= 9) greet = "Selamat pagi";
  else if (hrs >= 9 && hrs <= 15) greet = "Selamat siang";
  else if (hrs >= 15 && hrs <= 18) greet = "Selamat sore";
  else {
    greet = "Selamat malam";
  }

  const header = (
    <>
      <IonHeader className="ion-no-border" translucent>
        <IonToolbar color="primary">
          <IonTitle>
            <svg
              height="38"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 204.639 67"
              enableBackground="new 0 0 204.639 67"
              xmlSpace="preserve"
            >
              <path
                fill="#FFFFFF"
                d="M94.518,6.261v4.553h-7.926v24.145h-5.731V10.814h-7.886V6.261H94.518z M115.167,29.187h-11.503
	l-2.033,5.771h-6.056l10.568-28.372h6.544l10.528,28.372h-6.057L115.167,29.187z M113.623,24.837l-4.228-12.113l-4.227,12.113
	H113.623z M132.035,24.309v10.649h-5.731V6.261h10.446c3.387,0,5.94,0.813,7.662,2.439c1.721,1.626,2.581,3.835,2.581,6.625
	c0,2.737-0.888,4.919-2.662,6.545c-1.775,1.625-4.302,2.438-7.581,2.438H132.035z M141.181,15.325c0-1.436-0.393-2.533-1.179-3.292
	c-0.786-0.759-2.073-1.139-3.861-1.139h-4.105v8.821h4.105C139.501,19.716,141.181,18.252,141.181,15.325z M168.211,29.187h-11.503
	l-2.033,5.771h-6.056l10.568-28.372h6.544l10.528,28.372h-6.057L168.211,29.187z M166.667,24.837l-4.228-12.113l-4.227,12.113
	H166.667z M190.485,20.366l12.153,14.592h-6.951l-10.609-13.129v13.129h-5.731V6.261h5.731v12.886l10.649-12.886h6.91
	L190.485,20.366z M86.031,55.857H76.92l-1.817,4.882h-2.129l7.379-19.555h2.242l7.379,19.555h-2.157L86.031,55.857z M85.435,54.268
	L81.49,43.482l-4.002,10.786H85.435z M108.112,56.07c-0.814,1.504-2.011,2.659-3.59,3.463c-1.58,0.805-3.487,1.206-5.719,1.206
	h-6.045V40.73h6.045c3.368,0,5.965,0.885,7.791,2.654c1.826,1.77,2.739,4.215,2.739,7.337
	C109.333,52.783,108.926,54.566,108.112,56.07z M105.104,56.78c1.476-1.448,2.214-3.467,2.214-6.06c0-2.592-0.738-4.612-2.214-6.059
	s-3.624-2.171-6.443-2.171h-3.889v16.462h3.889C101.48,58.951,103.628,58.227,105.104,56.78z M132.35,41.155v19.584h-1.987V44.334
	l-6.784,16.405h-1.788l-6.812-16.349v16.349h-2.015V41.155h2.356l7.38,17.115l7.323-17.115H132.35z M138.708,40.73v20.01h-2.015
	V40.73H138.708z M158.008,60.739h-2.015l-10.956-16.717v16.717h-2.015V40.758h2.015l10.956,16.745V40.758h2.015V60.739z
	 M62.568,23.787l-0.256-0.035c-3.767-0.521-6.035-4.45-4.603-7.973l0.097-0.239c2.132-5.245-3.708-10.146-8.504-7.136l-0.219,0.137
	c-3.221,2.022-7.484,0.47-8.652-3.149l-0.079-0.246c-1.738-5.389-9.363-5.389-11.101,0l-0.079,0.246
	c-1.167,3.619-5.431,5.171-8.652,3.149l-0.219-0.137c-4.796-3.011-10.636,1.89-8.504,7.136l0.097,0.239
	c1.432,3.523-0.836,7.452-4.603,7.973l-0.256,0.035c-5.609,0.776-6.933,8.285-1.928,10.932l0.228,0.121
	c3.362,1.778,4.149,6.246,1.599,9.067l-0.173,0.192c-3.798,4.2,0.014,10.803,5.55,9.614l0.253-0.054
	c3.718-0.799,7.194,2.118,7.053,5.918l-0.01,0.258c-0.21,5.658,6.955,8.266,10.431,3.797l0.159-0.204
	c2.335-3.002,6.872-3.002,9.207,0l0.159,0.204c3.477,4.469,10.641,1.862,10.431-3.797l-0.01-0.258
	c-0.141-3.8,3.335-6.717,7.053-5.918l0.253,0.054c5.536,1.189,9.348-5.414,5.55-9.614l-0.173-0.192
	c-2.551-2.821-1.763-7.289,1.599-9.067l0.228-0.121C69.501,32.072,68.177,24.563,62.568,23.787z M34.802,53.702
	c-11.157,0-20.202-9.045-20.202-20.202s9.045-20.202,20.202-20.202S55.004,22.343,55.004,33.5S45.96,53.702,34.802,53.702z
	 M34.802,16.425c-9.43,0-17.075,7.645-17.075,17.075s7.645,17.075,17.075,17.075S51.877,42.93,51.877,33.5
	S44.233,16.425,34.802,16.425z M23.095,31.322l2.515-4.356h6.575l2.515-4.356h4.286L26.41,44.391v-7.424l3.259-5.645H23.095z
	 M43.995,40.034H37.42l-2.515,4.356h-4.286l12.576-21.781v7.424l-3.259,5.645h6.575L43.995,40.034z"
              />
            </svg>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
    </>
  );

  return (
    <PageLayout title="Dashboard" customHeader header={header}>
      <section
        style={{
          backgroundColor: "var(--ion-color-primary)",
          marginTop: "-10px",
          padding: "1em 1em 5em 1em",
        }}
      >
        <IonText color="secondary">
          <h1>
            {greet}, {auth?.currentUser?.displayName}!
          </h1>
        </IonText>
      </section>
      <section
        style={{
          marginTop: "-4em",
          padding: "0 1em",
        }}
      >
        <IonCard className='card-menu-container' mode="ios">
            <div style={{display:'grid', gridTemplateColumns:'33.33% 33.33% 33.33%', textAlign:'center'}}>
            <IonCard  mode="ios" button className="ion-padding card-menu" routerLink="/app/transaction/new" >
                  <IonIcon color="secondary" icon={addCircle} size="large" />
                  <IonLabel>
                    <p>Buat Transaksi</p>
                  </IonLabel>
                </IonCard>

                <IonCard  mode="ios" button className="ion-padding card-menu" routerLink="/app/product" >
                  <IonIcon color="secondary" icon={shirt} size="large" />
                  <IonLabel>
                    <p>Atur Produk</p>
                  </IonLabel>
                </IonCard>

                <IonCard  mode="ios" button className="ion-padding card-menu" routerLink="/app/finance" >
                  <IonIcon color="secondary" icon={cash} size="large" />
                  <IonLabel>
                    <p>Kelola Keuangan</p>
                  </IonLabel>
                </IonCard>

                <IonCard  mode="ios" button className="ion-padding card-menu" routerLink="/app/finance/account" >
                  <IonIcon color="secondary" icon={wallet} size="large" />
                  <IonLabel>
                    <p>Kas &amp; Bank</p>
                  </IonLabel>
                </IonCard>

            </div>
        </IonCard>
      </section>
    </PageLayout>
  );
};

export default Dashboard;
